module.exports = __webpack_public_path__ + "img/CybersecurityAwareness2022.695f62a3.jpg";